import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';

class Requests extends ChemComponent {
	constructor(props) {
		super(props);

		// start with from date of 90 days ago
		var from90Days = new Date();
		from90Days.setDate(from90Days.getDate() - 90);
		
		var search = {
			DATE_CREATED_FROM: this.dateTimeToMVC(from90Days),
			DATE_CREATED_TO: null,
			SHOP_ID: [],
			PI_NAME: '',
			JOB_REF: '',
			STATUS_ID: []
		};
		
		var requestListInit = this.copyTable(requestList);
		requestListInit.ajax.data = {
			search: search
		};

		this.state = {
			search: search,
			requestList: requestListInit,
			showSearch: false,
			searchCount: null,
			renderKey: 0
		};
		
		// store magnifier position separately so
		// it can be updated without triggering a re-render
		this.magPos = {};
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event) {
		var newRequestList = this.copyTable(requestList);
		newRequestList.ajax.data = { search: this.copyObject(this.state.search) };
		this.mergeState({
			requestList: newRequestList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		// create a magnifier position record for each photo
		for (var r = 0; r < data.Data.length; r++) {
			if (Array.isArray(data.Data[r].PHOTOS)) {
				for (var p = 0; p < data.Data[r].PHOTOS.length; p++) {
					var photoId = 'photo_' + data.Data[r].JOB_ID + '_' + p;
					
					// all photos are initially regular size
					if (!this.magPos[photoId]) {
						this.magPos[photoId] = {
							translate: '0px 0px',
							scale: '1',
							transition: 'all 0.3s',
							ref: React.createRef(),
							magnified: false,
							timestamp: new Date().getTime(),
							zIndex: 0
						};
					}
				}
			}
		}
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	renderPhotos(jobId, photos) {
		if (Array.isArray(photos) && photos.length > 0) {
			return photos.map((imgData, key) => {
				var photoId = 'photo_' + jobId + '_' + key;
				// create magnification record if it doesn't exist
				if (!this.magPos[photoId]) {
					this.magPos[photoId] = {
						translate: '0px 0px',
						scale: '1',
						transition: 'all 0.3s',
						ref: React.createRef(),
						magnified: false,
						timestamp: new Date().getTime(),
						zIndex: 0
					};
				}
				var style = {
					display: 'inline-block',
					marginTop: '' + (key === 0 ? 0 : 10) + 'px',
					maxWidth: '300px',
					maxHeight: '300px',
					translate: this.magPos[photoId].translate,
					scale: this.magPos[photoId].scale,
					transition: this.magPos[photoId].transition,
					position: 'relative',
					zIndex: this.magPos[photoId].zIndex
				};
				var alt = 'job image';
				return (<img key={key} id={photoId} ref={this.magPos[photoId].ref} style={style} src={imgData} alt={alt}
					onMouseOver={(event) => this.onMouseOverImage(event)}
					onMouseOut={(event) => this.onMouseOutImage(event)} />);
			});
		}
	}
	
	isTableCol(elem) {
		return (elem && elem.parentElement && elem.role === 'table' && elem.parentElement.className === 'col');
	}
	
	onMouseOverImage(event) {
		var self = this;
		
		// if we are not receiving this event during a transition
		if (!this.magPos[event.target.id] || new Date().getTime() - this.magPos[event.target.id].timestamp > 300) {
			// look for parent element with class 'col'
			var divCol;
			for (divCol = event.target; !this.isTableCol(divCol); divCol = divCol.parentElement) {}
			
			// if col element was found
			if (divCol) {
				// we actually want its parent
				divCol = divCol.parentElement;
				
				// get the scrollbar dimensions
				var scrollbars = {
					width: divCol.offsetWidth - divCol.clientWidth,
					height: divCol.offsetHeight - divCol.clientHeight
				};
				
				// find the coordinates of img and col
				var colRect = divCol.getBoundingClientRect();
				var imgRect = event.target.getBoundingClientRect();
				
				// adjust colRect to account for scrollbars
				colRect.width -= scrollbars.width;
				colRect.height -= scrollbars.height;
				
				// scale the image up by 2x
				imgRect.width *= 2;
				imgRect.height *= 2;
				
				// center the larger image around the original image
				imgRect.x -= (imgRect.width/4);
				imgRect.y -= (imgRect.height/4);
				
				// what is the current center x,y of img?
				var imgCenter = {
					x: imgRect.x + imgRect.width/2.0,
					y: imgRect.y + imgRect.height/2.0
				};
				
				// what would img x and y be if image were centered in col?
				var imgCentered = {
					x: colRect.x + (colRect.width - imgRect.width)/2.0,
					y: colRect.y + (colRect.height - imgRect.height)/2.0
				};
				
				// what is the center x,y of col?
				var colCenter = {
					x: colRect.x + colRect.width/2.0,
					y: colRect.y + colRect.height/2.0
				};
				
				var newImgRect = {
					x: imgRect.x,
					y: imgRect.y
				};
				
				// if img is right of center in col
				if (imgCenter.x > colCenter.x) {
					// if the right side of img is outside of col
					if (imgRect.x + imgRect.width > colRect.x + colRect.width) {
						// adjust img so that the right side of img is inside col
						// but do not push the center of img past the center of col
						newImgRect.x = Math.max((colRect.x + colRect.width) - imgRect.width, imgCentered.x);
					}
				} else if (imgCenter.x < colCenter.x) {
					// if the left side of img is outside of col
					if (imgRect.x < colRect.x) {
						// adjust img so that the left side of img is inside col
						// but do not push the center of img past the center of col
						newImgRect.x = Math.min(colRect.x, imgCentered.x);
					}
				}
				
				// if img is below center in col
				if (imgCenter.y > colCenter.y) {
					// if the bottom of img is outside of col
					if (imgRect.y + imgRect.height > colRect.y + colRect.height) {
						// adjust img so that the bottom of img is inside col
						// but do not push the center of img past the center of col
						newImgRect.y = Math.max((colRect.y + colRect.height) - imgRect.height, imgCentered.y);
					}
				} else if (imgCenter.y < colCenter.y) {
					// if the top of img is outside of col
					if (imgRect.y < colRect.y) {
						// adjust img so that the top of img is inside col
						// but do not push the center of img past the center of col
						newImgRect.y = Math.min(colRect.y, imgCentered.y);
					}
				}
				
				// make sure all other images are not magnified
				Object.keys(this.magPos).forEach(function(key) {
					if (key !== event.target.id) {
						self.magnifyImage(key, false);
					}
				});
				
				// if image is not already magnified
				if (!this.magPos[event.target.id].magnified) {
					// magnify the image that we clicked on, using percentages of bounding box
					this.magnifyImage(event.target.id, true, newImgRect.x - imgRect.x, newImgRect.y - imgRect.y);
				}
			}
		}
	}
	
	onMouseOutImage(event) {		
		// if we are not receiving this event during a transition
		if (new Date().getTime() - this.magPos[event.target.id].timestamp > 300) {
			this.magnifyImage(event.target.id, false);
		}
	}
	
	magnifyImage(imageId, magnified, dx, dy) {
		// update local magPos object
		if (magnified) {
			this.magPos[imageId].translate = '' + dx + 'px ' + dy + 'px';
			this.magPos[imageId].scale = '2';
			this.magPos[imageId].transition = 'all 0.3s';
			this.magPos[imageId].timestamp = new Date().getTime();
			this.magPos[imageId].magnified = true;
			this.magPos[imageId].zIndex = 1;
		} else {
			this.magPos[imageId].translate = '0px 0px';
			this.magPos[imageId].scale = '1';
			this.magPos[imageId].transition = 'all 0.3s';
			this.magPos[imageId].timestamp = new Date().getTime() - 300;
			this.magPos[imageId].magnified = false;
			this.magPos[imageId].zIndex = 0;
		}
		
		// update DOM element if there is one
		if (this.magPos[imageId].ref.current) {
			this.magPos[imageId].ref.current.style.translate = this.magPos[imageId].translate;
			this.magPos[imageId].ref.current.style.scale = this.magPos[imageId].scale;
			this.magPos[imageId].ref.current.style.transition = this.magPos[imageId].transition;
			this.magPos[imageId].ref.current.style.zIndex = this.magPos[imageId].zIndex;
		}
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'Requests',
			columns: exportColumns,
			search: this.state.search
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Requests</div>
						{this.state.showSearch && <ChemEdit parent={this} user={this.props.user} columns={requestSearch} data={this.state.search}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Requests' table={this.state.requestList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const requestSearch = [
	{ Header: 'Date Submitted From', accessor: 'DATE_CREATED_FROM', type: 'date', row: 0, col: 0 },
	{ Header: 'Date Submitted To', accessor: 'DATE_CREATED_TO', type: 'date', row: 0, col: 1 },
	{ Header: 'Request Group', accessor: 'SHOP_ID', type: 'list', row: 0, col: 2,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.SHOPS', order: 'SHOP_ID',
			search: { Attribute: 'SHOP_ID', Operator: 'in', LongList: [5,6] }}},
	{ Header: 'Lab Group', accessor: 'PI_NAME', row: 1, col: 0 },
	{ Header: 'Description', accessor: 'JOB_REF', row: 1, col: 1 },
	{ Header: 'Status', accessor: 'STATUS_ID', type: 'list', row: 1, col: 2,
		options: { value: 'STATUS_ID', label: 'STATUS_NAME', entity: 'RECHARGES.JOB_STATUS', order: 'STATUS_ID',
			search: { Attribute: 'STATUS_ID', Operator: 'in', LongList: [1,2,3] }}}
];

const requestList = {
	ajax: { 
		url: '/JobTrack/GetRequests',
		data: null,
		accessor: 'Data'
	},
	pageSize: 20,
	columns: [
		{ Header: 'Job ID', accessor: 'JOB_ID', width: 60 },
		{ Header: 'Date Submitted', accessor: 'ENTERED_DATE', width: 125 },
		{ Header: 'Request Group', accessor: 'SHOP_NAME', width: 125 },
		{ Header: 'Lab Group', accessor: 'PI_NAME', width: 125 },
		{ Header: 'Description', accessor: 'JOB_REF', width: 300 },
		{ Header: 'Status', accessor: 'STATUS_NAME', width: 125 },
		{ Header: 'Images', accessor: 'PHOTOS', width: 306,
			Cell: props => props.parent.renderPhotos(props.row.values.JOB_ID, props.value) }
	]
};

const exportColumns = [
	{ Header: 'Job ID', accessor: 'JOB_ID', width: 12 },
	{ Header: 'Date Submitted', accessor: 'ENTERED_DATE', width: 25 },
	{ Header: 'Request Group', accessor: 'SHOP_NAME', width: 25 },
	{ Header: 'Lab Group', accessor: 'PI_NAME', width: 25 },
	{ Header: 'Description', accessor: 'JOB_REF', width: 60 },
	{ Header: 'Status', accessor: 'STATUS_NAME', width: 25 }
];

export default withRouter(Requests);
